module.exports = __webpack_public_path__ + "img/circle__button__two.1e37eb27.svg";